
import { defineComponent } from '@nuxtjs/composition-api';
import { ProfilesShownBreakPoints } from '@/components/partials/sales-directory/types';
import type { SalesDirectoryPage } from '@/types/graphql';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import SalesProfileQuery from '~/apollo/queries/SalesDirectory/SalesDirectoryProfiles.gql';
import SalesDirectoryPagination from '~/components/partials/sales-directory/SalesDirectoryPagination.vue';
import { getProfilePath } from '~/components/partials/portfolio/common';

export default defineComponent({
  components: { SalesDirectoryPagination, BravadoTheme },
  middleware({ redirect, query }) {
    const { prefix, page } = query as Record<string, string>;
    const isPageNumberValid = Number(page) > 0 && !isNaN(+page);
    const isPagePrefixValid = prefix && prefix.length === 1;

    if (!prefix || !page || !isPageNumberValid || !isPagePrefixValid) {
      redirect('/sales-directory?prefix=A&page=1');
    }
  },
  async asyncData(context) {
    const client = context.app.apolloProvider?.defaultClient;
    if (!client) return;

    const { data } = await client.query({
      query: SalesProfileQuery,
      variables: { prefix: 'A', page: 1, perPage: ProfilesShownBreakPoints.Default },
    });
    return {
      salesDirectoryProfiles: data.salesDirectoryProfiles,
    };
  },
  data() {
    return {
      salesDirectoryProfiles: null,
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      profilesShown: ProfilesShownBreakPoints.Default,
    };
  },
  head() {
    return this.$seo({
      // @ts-expect-error
      title: `Directory of Salespeople | "${this.prefix.toUpperCase()}", page ${this.pageNumber}`,
      // @ts-expect-error
      description: `Find sales experts over the world easily to increase sales of your product and company | "${this.prefix.toUpperCase()}", page ${
        // @ts-expect-error
        this.pageNumber
      }`,
      // @ts-expect-error
      canonical: `${this.$route?.path}?prefix=${this.prefix}&page=${this.pageNumber}`,
    });
  },
  apollo: {
    salesDirectoryProfiles: {
      query: SalesProfileQuery,
      variables() {
        return {
          prefix: this.prefix,
          page: this.pageNumber,
          perPage: this.profilesShown || ProfilesShownBreakPoints.Default,
        };
      },
    },
  },
  computed: {
    prefix(): string {
      return (this.$route.query.prefix as string) || '';
    },
    pageNumber(): number {
      return +this.$route.query.page;
    },
    queryLoading(): boolean {
      return this.$apollo.queries.salesDirectoryProfiles?.loading;
    },
    numberOfPages(): number {
      return (this.salesDirectoryProfiles as unknown as SalesDirectoryPage)?.totalPages;
    },
    selectedPageNumber(): number {
      return (this.salesDirectoryProfiles as unknown as SalesDirectoryPage)?.currentPage;
    },
  },
  watch: {
    '$breakpoint.current': {
      immediate: true,
      handler(sizeName: string) {
        sizeName.match(/xl|lg/) && (this.profilesShown = ProfilesShownBreakPoints.Desktop);
        sizeName.match(/sm|md/) && (this.profilesShown = ProfilesShownBreakPoints.Tablet);
        sizeName === 'xs' && (this.profilesShown = ProfilesShownBreakPoints.Desktop);
      },
    },
  },
  methods: {
    getProfilePath,
  },
});
